export default "__VITE_ASSET__DZOx1dQg__"